import React from 'react';
import styles from './BubbleLabel.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const BubbleLabel = ({
  bubbleType,
  bubbleSVG,
  labelTitle,
  labelDesc,
  dataTarget,
  swiperShow
}) => {
  return (
    <div
      id={bubbleType}
      className={cx('bubble', bubbleType)}
      data-target={dataTarget}
      onClick={() => swiperShow()}
    >
      {bubbleSVG}
      <div className={cx('bubble-label')}>
        <h3 className={cx('bubble-label__title')}>{labelTitle}</h3>
        <p className={cx('bubble-label__desc')}>{labelDesc}</p>
      </div>
    </div>
  );
};

export default BubbleLabel;



// WEBPACK FOOTER //
// ./src/app/components/molecules/BubbleLabel/BubbleLabel.js